import CardContent from "@mui/material/CardContent";
import { styled } from "@mui/material/styles";
import * as Config from "config";

const marketplaceChromeHeight =
  Config.elementHeight.appBar + Config.elementHeight.marketplaceSearchBar + Config.elementHeight.footer;

const MarketplaceChatCardContent = styled(CardContent)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  boxSizing: "border-box",
  boxShadow: theme.shadows[6],
  display: "flex",
  flexDirection: "column",
  height: `calc(100dvh - ${marketplaceChromeHeight}px - ${theme.spacing(4)})`,
  maxHeight: `calc(100dvh - ${marketplaceChromeHeight}px - ${theme.spacing(4)})`,
  minHeight: 0,
  overflow: "hidden",
  position: "fixed",
  right: theme.spacing(3),
  top: `calc(${Config.elementHeight.appBar + Config.elementHeight.marketplaceSearchBar}px + ${theme.spacing(2)})`,
  width: `min(${theme.spacing(92)}, calc(100vw - ${theme.spacing(6)}))`,
  zIndex: theme.zIndex.drawer + 1,
  [theme.breakpoints.down("md")]: {
    borderLeft: 0,
    borderRadius: 0,
    borderRight: 0,
    bottom: 0,
    height: `calc(100dvh - ${Config.elementHeight.appBar}px)`,
    left: 0,
    maxHeight: `calc(100dvh - ${Config.elementHeight.appBar}px)`,
    padding: theme.spacing(1.5),
    paddingBottom: theme.spacing(2.5),
    right: 0,
    top: Config.elementHeight.appBar,
    width: "100vw",
  },
  [theme.breakpoints.down("sm")]: {
    height: `calc(100dvh - ${theme.spacing(7)})`,
    maxHeight: `calc(100dvh - ${theme.spacing(7)})`,
    top: theme.spacing(7),
  },
}));

export default MarketplaceChatCardContent;
